<template>
  <el-table :data="tableData" border size="mini" height="560">
    <el-table-column
      property="rowNum"
      label="序号"
      align="center"
      width="50"
    ></el-table-column>
    <el-table-column
      property="videoTitle"
      label="名称"
      align="center"
      min-width="150"
    ></el-table-column>
    <el-table-column
      property="learnTime"
      label="成绩"
      align="center"
      width="130"
    ></el-table-column>
    <el-table-column
      property="learnTime"
      label="考核认定成绩"
      align="center"
      width="130"
    ></el-table-column>
  </el-table>
</template>

<script>
import * as api from '@/api/learningOutcome/learningOutcome'
export default {
  props: ['courseScoreId'],
  data() {
    return {
      tableData: [],
    }
  },
  created() {
    this.getCourseScoreInfo()
  },
  methods: {
    getCourseScoreInfo() {
      api
        .getCourseScoreInfo({
          courseScoreId: this.courseScoreId,
          infoStatus: 0,
        })
        .then((data) => {
          const { code, data: list, msg } = data.data
          if (code === 100000) {
            this.tableData = list.result
          } else {
            this.$message.error(msg)
          }
        })
    },
  },
}
</script>

<style>
</style>